module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Join-3-ef35015f0e71a2693b1f8c55784e25d3.svg";